import { merge } from "rxjs";
import { delay, filter } from "rxjs/operators";
import { combineChecks } from "../../guards/combineChecks";
import { guard } from "../../guards/guard";
import { pathEmpty } from "../../guards/pathEmpty";
import { TypeActionModal } from "../../modals/actionModal";
import { IdModal } from "../../modals/IdModal";
import { checkTutorialConstructClickBuyButton } from "../checks/checkTutorialConstructClickBuyButton";
import { checkTutorialNextStepConfigExists } from "../checks/checkTutorialNextStepConfigExists";
import { checkTutorialQuestClickShowMe } from "../checks/checkTutorialQuestClickShowMe";
import { pathTutorialConstructClickBuyButton } from "../path/pathTutorialConstructClickBuyButton";
import { pathTutorialUpdate } from "../path/pathTutorialUpdate";
export var epicTutorialOnModalOpen = function (action$, state$, deps) {
    var actionConstructClickBuyButton$ = action$.pipe(filter(function (action) {
        return action.type === TypeActionModal.Open && action.modalId === IdModal.BuildingList;
    }), guard(state$, deps, pathEmpty)([
        combineChecks([
            checkTutorialNextStepConfigExists,
            checkTutorialConstructClickBuyButton,
        ])(pathTutorialConstructClickBuyButton),
    ]));
    var actionQuestClickShowMe$ = action$.pipe(filter(function (action) {
        return action.type === TypeActionModal.Open && action.modalId === IdModal.Quests;
    }), delay(10), guard(state$, deps, pathEmpty)([
        combineChecks([checkTutorialNextStepConfigExists, checkTutorialQuestClickShowMe])(pathTutorialUpdate),
    ]));
    return merge(actionQuestClickShowMe$, actionConstructClickBuyButton$);
};



//////////////////
// WEBPACK FOOTER
// ./src/features/tutorial/epics/epicTutorialOnModalOpen.ts
// module id = 2483
// module chunks = 3